import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
  width={props.width || "20"}
  height={props.height || "20"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_219_2225)">
      <path
        d="M3.99987 10.8655C5.02443 7.6038 7.60395 5.02424 10.8657 3.99968L9.13191 2.26585C8.596 1.72994 7.88357 1.43486 7.12568 1.43486C6.83349 1.43486 6.54819 1.47917 6.27698 1.5638C6.53617 2.83432 6.17476 4.20745 5.19118 5.19098C4.437 5.94515 3.4343 6.36049 2.36772 6.36049C2.09428 6.36049 1.82509 6.33273 1.56312 6.27941C1.47904 6.54979 1.43506 6.83422 1.43506 7.12542C1.43506 7.88326 1.73019 8.59575 2.26605 9.13166L3.99987 10.8655Z"
        fill="#556987"
      />
      <path
        d="M20.8743 1.43486C20.1164 1.43486 19.404 1.72994 18.868 2.26585L17.1343 3.99968C20.3961 5.02424 22.9756 7.6038 24.0001 10.8655L25.734 9.13171C26.2698 8.5958 26.565 7.88331 26.565 7.12548C26.565 6.83422 26.521 6.54985 26.4369 6.27946C26.1749 6.33279 25.9058 6.36054 25.6323 6.36054C24.5657 6.36054 23.563 5.94521 22.8088 5.19103C21.8252 4.20745 21.4638 2.83438 21.723 1.56385C21.4518 1.47917 21.1665 1.43486 20.8743 1.43486Z"
        fill="#556987"
      />
      <path
        d="M7.12568 26.5651C7.88357 26.5651 8.596 26.2701 9.13191 25.7341L10.8657 24.0003C7.60395 22.9758 5.02443 20.3962 3.99987 17.1345L2.26605 18.8683C1.73019 19.4042 1.43506 20.1167 1.43506 20.8745C1.43506 21.1658 1.47904 21.4501 1.56312 21.7205C1.82509 21.6672 2.09422 21.6395 2.36772 21.6395C3.4343 21.6395 4.437 22.0548 5.19118 22.809C5.94535 23.5631 6.36068 24.5658 6.36068 25.6324C6.36068 25.9059 6.33293 26.175 6.27961 26.437C6.55005 26.5212 6.83442 26.5651 7.12568 26.5651Z"
        fill="#556987"
      />
      <path
        d="M20.8744 26.5651C21.1656 26.5651 21.45 26.5212 21.7204 26.4371C21.6671 26.1751 21.6393 25.906 21.6393 25.6325C21.6393 24.5659 22.0547 23.5632 22.8088 22.809C23.563 22.0549 24.5657 21.6395 25.6323 21.6395C25.9057 21.6395 26.1749 21.6673 26.4369 21.7206C26.521 21.4502 26.565 21.1658 26.565 20.8746C26.565 20.1167 26.2698 19.4043 25.734 18.8684L24.0001 17.1346C22.9756 20.3963 20.3961 22.9758 17.1343 24.0004L18.8681 25.7342C19.4041 26.27 20.1166 26.5651 20.8744 26.5651Z"
        fill="#556987"
      />
      <path
        d="M2.36749 4.72152C5.46062 4.67169 5.46002 0.0628911 2.36738 0.0136108C-0.725643 0.0633828 -0.725042 4.67224 2.36749 4.72152Z"
        fill="#556987"
      />
      <path
        d="M23.9677 4.03203C26.2188 6.17162 29.4362 2.95327 27.2966 0.702987C25.0456 -1.43655 21.8283 1.7818 23.9677 4.03203Z"
        fill="#556987"
      />
      <path
        d="M27.2972 23.968C25.0461 21.8283 21.8287 25.0467 23.9682 27.297C26.2193 29.4366 29.4366 26.2182 27.2972 23.968Z"
        fill="#556987"
      />
      <path
        d="M4.03203 23.968C1.78092 21.8283 -1.43645 25.0467 0.703094 27.297C2.95414 29.4366 6.17146 26.2182 4.03203 23.968Z"
        fill="#556987"
      />
      <path
        d="M14 22.8403C18.8823 22.8403 22.8403 18.8824 22.8403 14C22.8403 9.11766 18.8823 5.15973 14 5.15973C9.1176 5.15973 5.15967 9.11766 5.15967 14C5.15967 18.8824 9.1176 22.8403 14 22.8403Z"
        fill="#556987"
      />
    </g>
    <defs>
      <clipPath id="clip0_219_2225">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
